import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ISurpriseCreation} from "../types/ISurpriseCreation";
import {AdCreationError} from "./creation_error_class";

export async function fetchSurpriseAd(creationId: number) {
    try {
        const url = apiV2Link.adverts.unveiled.detail({unveiledId: creationId});
        const creationDetails = await getRequest(clientRpRequestMeta, url);

        return creationDetails as ISurpriseCreation;
    } catch (error) {
        notifyBugsnag(error, "fetchSurpriseAd: catch", {originalError: JSON.stringify(error)});

        throw new AdCreationError(`creation ${creationId} not found`);
    }
}
